import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material';

import { COLORS } from '../IndividualPlan/tokens';

type DeleteFileModalProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeleteFileModal({ open, onCancel, onConfirm }: DeleteFileModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, color: COLORS.ink, pb: 1 }}>
        Are You Sure You Want To Delete This File?
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, color: COLORS.muted, lineHeight: 1.5 }}>
          If you delete this file, the data it contains will not be included in any future reports or
          plans. Any existing report or plan that uses the data in this file will not change.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Link
          component="button"
          underline="hover"
          onClick={onCancel}
          sx={{ color: '#1F1F70', fontWeight: 600, fontSize: 14, mr: 2 }}
        >
          Cancel
        </Link>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            bgcolor: '#1F1F70',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
            borderRadius: 1.5,
            '&:hover': { bgcolor: '#18185A' },
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
